import { render, staticRenderFns } from "./AgreementAgree.vue?vue&type=template&id=11b5f859&"
import script from "./AgreementAgree.vue?vue&type=script&lang=js&"
export * from "./AgreementAgree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports